import axios from "axios";

const state = () => ({
    isBusy: false,
    quickSummary: [],
    affiliateQuickSummary: [],
    management: [],
    marketing: [],
    countries: [],
    countryDetails: [],
    totalCount: 0
})

// getters
const getters = {
    sortedCountriesByPlayersCount: state => [...state.countries].sort((a,b) => a.playersCount + b.playersCount)
}

// mutations
const mutations = {
    setIsBusy(state, data) {
        state.isBusy = data;
    },
    setQuickSummary(state, data) {
        state.quickSummary = data;
    },
    setAffiliateQuickSummary(state, data) {
        state.affiliateQuickSummary = data;
    },
    setManagement(state, data) {
        state.management = data;
    },
    setMarketing(state, data) {
        state.marketing = data;
    },
    setCountries(state, data) {
        state.countries = data;
    },
    setCountryDetails(state, data) {
        state.countryDetails = data;
    }
}

// actions
const actions = {
    getQuickSummary({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/quickSummaryReport?';
        url = date && date.dateFrom ? `${url}&fromDate=${date.dateFrom}` : url;
        url = date && date.dateTo ? `${url}&toDate=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setQuickSummary', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getAffiliateQuickSummaryReport({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/affiliateQuickSummaryReport?';
        url = date && date.dateFrom ? `${url}&fromDate=${date.dateFrom}` : url;
        url = date && date.dateTo ? `${url}&toDate=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setAffiliateQuickSummary', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getManagementReport({commit}, payload) {
        commit('setIsBusy', true);

        let url = `/api/report/managementReport`;
        url = payload && payload.country ? `${url}/${payload.country}?` : `${url}?`;
        url = payload && payload.marketingCosts ? `${url}&marketingCosts=${payload.marketingCosts}` : url;
        url = payload && payload.dateFrom ? `${url}&fromDate=${payload.dateFrom}` : url;
        url = payload && payload.dateTo ? `${url}&toDate=${payload.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setManagement', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getMarketingReport({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/marketingReport?';
        url = date && date.dateFrom ? `${url}&fromDate=${date.dateFrom}` : url;
        url = date && date.dateTo ? `${url}&toDate=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setMarketing', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getProfileCountriesReport({commit}, date) {
        commit('setIsBusy', true);

        let url = '/api/report/profileCountriesReport?';
        url = date && date.dateFrom ? `${url}&fromDate=${date.dateFrom}` : url;
        url = date && date.dateTo ? `${url}&toDate=${date.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setCountries', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getProfileCountriesDetailsReport({commit}, payload) {
        commit('setIsBusy', true);

        let url = `/api/report/profileCountriesDetailsReport/${payload.country}`;
        url = `${url}?${payload.pagination}`;
        url = payload && payload.dateFrom ? `${url}&fromDate=${payload.dateFrom}` : url;
        url = payload && payload.dateTo ? `${url}&toDate=${payload.dateTo}` : url;

        axios.get(url)
            .then(function (response) {
                commit('setCountryDetails', response.data);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
